import {Action, getModule, Module, VuexModule} from 'vuex-module-decorators';
import {ApiError} from '@/core/error/interface/api-error.interface';
import {store} from '@/store';
import {ApiErrorDetails} from '@/core/error/interface/api-error-details.interface';
import {AlertStore} from '@/shared/config/store/alert.store';
import {Dictionary} from 'lodash';
import {AlertType} from '@/core/alert/enum/alert-type.enum';

@Module({
    dynamic: true,
    namespaced: true,
    name: 'error',
    store,
})
export class ErrorStore extends VuexModule {
    @Action
    async handleApiError(error?: ApiError): Promise<Dictionary<string> | null> {
        switch (error.statusCode) {
            case 400:
                if (error.details) {
                    getModule(AlertStore).aValidationDialog(error.details ?? []);
                    return error.details.reduce((result: Dictionary<string>, detail: ApiErrorDetails) => {
                        result[detail.field] = detail.message;
                        return result;
                    }, {});
                } else {
                    getModule(AlertStore).aSimpleDialog({
                        title: error.name,
                        text: {
                            i18nKey: 'defaults.translated',
                            parameters: {
                                message: error.detailMessage,
                            },
                        },
                        type: AlertType.ERROR,
                    });
                    return null;
                }
            default:
                getModule(AlertStore).aSimpleDialog({
                    title: error.message + '.title',
                    text: error.detailMessage ?? error.message + '.text',
                    type: AlertType.ERROR,
                });
                return null;
        }
    }
}
